// extracted by mini-css-extract-plugin
export default {"grid":"invoice-sidebar-actions_grid__l-YIU"};